'use client';

import Link from 'next/link';
import { useTranslation } from '@/context/LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-gradient-to-r from-unmulGreen to-unmulDarkGreen text-white">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl font-serif font-bold mb-6" data-aos="fade-up">{t('cta.title')}</h2>
        <p className="text-xl text-green-100 mb-10 max-w-2xl mx-auto" data-aos="fade-up" data-aos-delay="100">
          {t('cta.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-aos="fade-up" data-aos-delay="200">
          <Link href="#admission" className="px-8 py-4 bg-unmulYellow text-unmulDarkGreen font-bold rounded-lg text-lg hover:bg-white transition shadow-xl">
            <FontAwesomeIcon icon={faGraduationCap} className="mr-3" /> {t('cta.register')}
          </Link>
          <Link href="/profil/peta-kampus" className="px-8 py-4 bg-transparent border-2 border-white/50 text-white font-bold rounded-lg text-lg hover:bg-white/10 transition">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-3" /> {t('cta.visitCampus')}
          </Link>
        </div>
      </div>
    </section>
  );
}
